import React from 'react'
import ViewDetails from '../../Portals/posts/ViewDetails'

function ViewPostDetails() {
  return (
    <div className='p-8'>
      <ViewDetails />
    </div>
  )
}

export default ViewPostDetails
